import { freeze } from '../object';

export const LOCAL_STORAGE_KEYS = freeze({
  CONNECTED: 'connected',
  NETWORK: 'SELECTED_NETWORK',
});
